export enum AtpCustomerCategory {
    Commodity = 'Cliente CB Commodity',
    Base = 'Cliente Base',
}
